<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="epigraph"><a id="start"><i>Dawn like’ a thousand shining spears</i></a></p><a id="start">
<p class="noind"><i>Terrible in the east appears;</i></p>
<p class="noind"><i>Hide me, you leaves of lovely gloom</i></p>
<p class="noind"><i>Where the young dreams like lilies bloom.</i></p>
<p class="poem3" style="margin-top:20px;"><i>In vain I turn aside to where</i></p>
<p class="poem3"><i>Stars made a palace of the air;</i></p>
<p class="poem3"><i>In vain I hide my face away</i></p>
<p class="poem3"><i>From the too bright invading day.</i></p>
<p class="poem3" style="margin-top:20px;"><i>That which is come requires of me</i></p>
<p class="poem3"><i>My utter truth and mystery.</i></p>
<p class="poem3"><i>Return, you dreams, return to night</i></p>
<p class="poem3"><i>My lover is the armed light.</i></p>
<p class="right" style="margin-top:20px;">LAURENCE BINYON</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4epigraph.vue?643d3f68